import { FC, useEffect, useMemo } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { numberFormatter } from '../../../../config/utils';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { useHighflyerStateSlice } from '../../../../store/slices/highflyerState/selectors';
import { highflyerStateActions } from '../../../../store/slices/highflyerState/slice';

import styles from './MultiplierCellConnected.module.css';

export const MultiplierCellConnected: FC = () => {
  const isMultiplier = parseFloat(useHighflyerStateSlice.getMultiplier()).toFixed(2);
  const locale = useSettingsSlice.currentLanguage();
  const currentStatus = useGameStateSlice.getCurrentStatus();
  const isJackpot = useHighflyerGameStateSlice.getJackpot();
  const formatedNumber = useMemo(() => {
    return numberFormatter(Number(isMultiplier), locale, false);
  }, [locale, isMultiplier]);

  const mods = useModifiers(styles, 'multiplerContainer', {
    multiplierCrash:
      !isJackpot &&
      ([GameStatus.Result].includes(currentStatus as GameStatus) ||
        [GameStatus.GameCancelled].includes(currentStatus as GameStatus)),
  });

  useEffect(() => {
    if ([GameStatus.Result].includes(currentStatus as GameStatus)) highflyerStateActions.setMultiplier(null);
  }, [currentStatus]);

  return (
    isMultiplier && (
      <div className={styles.multiplerContainer}>
        {!isJackpot && currentStatus === GameStatus.Result && (
          <div className={styles.multiplierFlewAway}>
            <L10nText tk="CRASH_FLEW_AWAY" />
          </div>
        )}
        <div className={`${styles.multiplierValue} ${mods}`}>
          {formatedNumber.split('').map((el: string) => {
            return (
              <span className={styles.mulContainerEle} data-char={el} key={el + 'mul'}>
                {el}
              </span>
            );
          })}
          <span className={styles.containerEleSuffix}>x</span>
        </div>
      </div>
    )
  );
};
